// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCustomerPartNumbers from "@vanmeter/App/Handlers/CPN/loadCustomerPartNumbers";
import { xIsAuthenticated } from "@vanmeter/App/Store/Selectors/GeneralSelectors";

export const XngExpandApiParameter: typeof PopulateApiParameter = (props: any) => {
    const ourExpand = ["cartLines", "restrictions", "properties", "validation", "paymentOptions", "hiddenProducts"];
    const state = props.getState();
    const pageType = getCurrentPage(state).type;
    const appSettings = getSettingsCollection(state);
    props.apiParameter.expand = [...new Set([...props.apiParameter.expand, ...ourExpand])];
    const timestamp = `time${new Date().getTime()}`;

    // XNG-Change make sure we expand tax if needed on the minicart.
    if (props.needFullCart) {
        props.apiParameter.expand = [...new Set([...(props.apiParameter.expand || []), "carriers", "costCodes"])];
    } else if (appSettings.cartSettings.showTaxAndShipping) {
        props.apiParameter.expand.push("tax");
    } else {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "shipping");
    }
    // <XNG-Change> expanding carriers on the cart page for ship fulfillment method
    const fulfillmentMethod = state.xCommon?.fulfillmentMethodState?.value;
    if (pageType === "CartPage" && fulfillmentMethod === FulfillmentMethod.Ship) {
        props.apiParameter.expand.push("carriers");
    }
    // </XNG-Change>
    props.apiParameter.expand?.push(timestamp);
};

// XNG-Changes: CPN - Cart, Checkout Process, Mini Cart
const xloadCustomerPartNumbers: typeof PopulateApiParameter = props => {
    const isAuth = xIsAuthenticated(props.getState());

    if (!props.apiResult?.cart?.cartLines || props.apiResult.cart.cartLines.length === 0 || !isAuth) {
        return;
    }
    const productIds = props.apiResult.cart.cartLines.map(cartLine => cartLine.productId);

    props.dispatch(
        loadCustomerPartNumbers({
            productIds,
        }),
    );
};

addToEndOfChain(chain, xloadCustomerPartNumbers);
addToChainAfter(chain, PopulateApiParameter, XngExpandApiParameter);
